var documentReady = function () {
  
  if($('body').is('.template-product') || $('body').is('.template-collection') ) {
    $('ul.menu:first-of-type').find('.menu-item-has-children:first-child > a').addClass('active');
     	$('ul.menu:first-of-type').find('.menu-item-has-children:first-child > .sub-menu').css('display','block');
   }

  $('#show-register-form').click(function(e){
    e.preventDefault();
    $('.register-expand').toggleClass('show');
  });
  
// // Tooltip only Text
    $(document).mousemove(function(e){
        $('#tooltip').css({
        left:  e.clientX,
        top:   e.clientY
        });
        $('.form-row > div > .radio-holder, .form-row > .radio-features').hover(function(){
          var img = $(this).find('input').data('option-img');
           
         var label = $(this).find("label").html();
         var newHTML = label;
         if(img!= undefined) newHTML = '<span class="has-img">' +label + '<br/><img src="'+img+'"/></span>';
		 var eq =$(this).index() + 1;
          
         $('#tooltip span').attr('id', $(this).find('input').attr('value'));
          
          $('#tooltip span').html(newHTML);
		 $('#tooltip').attr('class', 'visible');


        },function(){
            $('#tooltip').attr('class', 'hidden');

        });
      
        $('.radio-holder, .radio-features').mouseleave(function(){
            $('#tooltip').attr('class', 'hidden');
        });
        $('.cart-reaveal').hover(function(){
                 $('#tooltip').attr('class', 'hidden');
        });
    });
  

//   PRODUCT IMAGES VS CYLINDO SWAP 
  var productGallery = $('.product__images.gallery .gallery-image');
  if(productGallery.length > 0) $('.product__images.gallery').parent().addClass('has-gallery-images');
      $('button#gallery-swap').on('click', function () {
 
        if($(this).closest('.product__images_container').hasClass('show-gallery')){  
            $(this).html('View Photos');
           $(this).closest('.product__images_container').removeClass('show-gallery');
        }
        else{
          $(this).html('View in 3D');
           $(this).closest('.product__images_container').addClass('show-gallery');
        }
      
    });
  
  
  
//   		SWATCHES
    $('.open-popup-btn').on('click', function () {
      $(this).addClass('clicked');
      openSwatchPanel();
    });
    $('.open-popup-btn2').on('click', function () {
      $(this).addClass('clicked');
      openFinishesPanel();
    });
    $('.open-popup-btn3').on('click', function () {
      $(this).addClass('clicked');
      openCasegoodsPanel();
    });
   $('.close-popup-btn').on('click', function () {
      closeSwatchPanel();  
     closeFinishesPanel();
     closeCasegoodsPanel();
    });
  
   $('.dock-popup-btn').on('click', function () {
        $('.swatch-popup').toggleClass('docked');
        $('.finishes-popup').toggleClass('docked');
        $('.wood-swatch-popup').toggleClass('docked');

    });

}
  function openSwatchPanel(){
        $('.swatch-popup').show();
       $('.swatch-popup').find('input').prop('disabled',false);
  }

  function closeSwatchPanel(){
      $('.swatch-popup').hide();
       $('.swatch-popup').find('input').prop('disabled',true);
       $('.swatch-popup').find('input').prop('checked',false);

  }
   function openFinishesPanel(){
        $('.finishes-popup').show();
       $('.finishes-popup').find('input').prop('disabled',false);
  }

  function closeFinishesPanel(){
      $('.finishes-popup').hide();
       $('.finishes-popup').find('input').prop('disabled',true);
       $('.finishes-popup').find('input').prop('checked',false);

  } 
   function openCasegoodsPanel(){
        $('.wood-swatch-popup').show();
       $('.wood-swatch-popup').find('input').prop('disabled',false);
  }

  function closeCasegoodsPanel(){
      $('.wood-swatch-popup').hide();
       $('.wood-swatch-popup').find('input').prop('disabled',true);
       $('.wood-swatch-popup').find('input').prop('checked',false);

  } 


// Document Ready Listener
if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") { documentReady(); } else { document.addEventListener('DOMContentLoaded', documentReady); };
